export class poliglotLink {
    constructor(link, blank, local=true, text=null, className=null) {
        this.link = link;
        this.blank = blank;
        this.local = local;
        this.text = text;
        this.className = className;
    };
}
